declare var Handsontable

const DateEditorBase = (Handsontable.editors.DateEditor as any).prototype as any
export const DateEditorHelper = DateEditorBase.extend()

DateEditorHelper.prototype.setValue = function(value) {
  this.originalValue = value
}

DateEditorHelper.prototype.showDatepicker = function(...args: any[]) {
  DateEditorBase.showDatepicker.apply(this, ...args)
  const offset = (this.TD as HTMLElement).getBoundingClientRect()
  const picker = this.$datePicker.el as HTMLElement
  const pickerRect = picker.getBoundingClientRect()
  if (offset.top >= window.innerHeight - pickerRect.height) {
    this.datePickerStyle.top = (window.pageYOffset + offset.top - pickerRect.height) + "px";
  }
  if (offset.left >= window.innerWidth - pickerRect.width) {
    this.datePickerStyle.left = (window.pageXOffset + offset.right - pickerRect.width) + "px";
  }
}


// WEBPACK FOOTER //
// ./src/widgets/spread_sheet/spread-sheet/plugins/datepicker-helper.ts